import { render, staticRenderFns } from "./PartnerTable.vue?vue&type=template&id=9b8677a0&scoped=true&"
import script from "./PartnerTable.vue?vue&type=script&lang=js&"
export * from "./PartnerTable.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTable.vue?vue&type=style&index=0&id=9b8677a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8677a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VIcon,VSimpleTable,VSpacer,VSystemBar})
